module.exports = __webpack_public_path__ + "img/angle_150.8bd17c35.jpg";